export const reportInventoryStockTypes = {
  SET_INVENTORY_STOCK_FILTERS: 'SET_INVENTORY_STOCK_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
